module.exports = __webpack_public_path__ + "static/media/react.d783f6d4.png";